import type { IEquipment } from '@model/equipment';

export const getEquipmentName = (
  equipment: IEquipment,
  equipmentType: string,
  t: (text: string) => string,
) => {
  if (equipmentType === 'node') {
    return t('Waites System Node');
  }

  if (equipmentType === 'gateway') {
    return t('Waites System Gateway');
  }

  if (equipmentType === 'router') {
    return t('Waites System Repeater');
  }

  return equipment?.name;
};
